const CommunityActionTypes = {
  FETCH_COMMUNITY_START: 'FETCH_COMMUNITY_START',
  FETCH_COMMUNITY_SUCCESS: 'FETCH_COMMUNITY_SUCCESS',
  FETCH_COMMUNITY_FAILED: 'FETCH_COMMUNITY_FAILED',
  DESTROY_COMMUNITY: 'DESTROY_COMMUNITY',
};

export default CommunityActionTypes;
